import { userApi } from "@/core/data/api";

export default async (values) => {
  return await userApi.login(values);
};
